import { combineReducers } from "redux";
import flagshipMain from "./appReducer";
import flagshipTime from "./timeReducer";
import { createForms } from "react-redux-form";
import { modelReducer } from "react-redux-form";
import { routerReducer } from "react-router-redux";

import {
  initialLoginFormState,
  initialFieldConfigFormState
} from "./initialState";

const rootReducer = combineReducers({
  ...createForms({
    login: initialLoginFormState,
    fieldConfigForm: initialFieldConfigFormState
  }),
  login: modelReducer("login"),
  main: flagshipMain,
  time: flagshipTime,
  routing: routerReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js